module.exports = __webpack_public_path__ + "img/work_place.ea3ed94d.png";